module.exports = __webpack_public_path__ + "static/media/WEBSITE_JLE.e416debf.jpg";